export const ResetEmailForm = {
  if: (el, s) => !s.token,
  flow: 'column',
  gap: 'A',
  flex: '1',
  height: '100%',
  '@mobileL': {
    align: 'center unset',
    height: 'unset'
  },
  childExtends: 'InputField',
  childProps: {
    width: '100%',
    Title: { tag: 'span' },
    Input: {
      width: '100%',
      theme: 'field',
      background: 'hover',
      minHeight: 'controlH',
      round: 'radiusControl',
      fontSize: 'Z2',
      padding: '0 A'
    }
  },
  Email: {
    Title: {
      text: '{{ auth.resetEmail.label | polyglot }}'
    },
    Input: {
      // One-way mirror only — DO NOT bind `value: (el, s) => s.email`.
      // That factory re-renders the input on every state change and
      // races with native typing, intermittently clearing the field
      // mid-keystroke. The submit handler reads state with a DOM
      // fallback (see reset-password.js _submitRequestReset) so this
      // input owns its own live value; state stays in sync via
      // onInput for the gating UI (Label/touched).
      autocomplete: 'username',
      name: 'email',
      type: 'email',
      ariaLabel: (el) => el.call('polyglot', 'auth.resetEmail.label'),
      required: true,
      autocapitalize: 'none',
      spellcheck: false,
      // A white-label host never shows the platform's own address as the
      // example (it named symbo.ls on a tenant's signup).
      placeholder: (el, s) =>
        el.call(
          'polyglot',
          s && s.root && s.root.whitelabelBrand
            ? 'auth.whitelabel.emailPlaceholder'
            : 'auth.resetEmail.placeholder'
        ),
      onInput: (ev, el, s) => {
        s.update({
          touched: true,
          email: el.node.value
        })
      }
    },
    Label: {
      show: (el, st) => st.touched === true && !st.email,
      color: 'red',
      text: '{{ auth.resetEmail.required | polyglot }}'
    }
  },
  ModalFooter: {
    // White-label host: flush with the fields (the brand footer's '0 -X'
    // bleed is a modal affordance; on the branded card it set the button
    // off the field edges).
    isBranded: (el, s) => !!(s && s.root && s.root.whitelabelBrand),
    '.isBranded': { margin: '0', padding: 'Z 0 0' },
    ignoreChildExtends: true,
    Title: null,
    Input: null,
    display: 'flex',
    flow: 'row',
    width: '100%',
    maxWidth: 'unset',
    align: 'center space-between',
    gap: 'Z',
    padding: 'B1 0 0',
    '@mobileL': {
      flow: 'column',
      gap: 'A2',
      childProps: {
        width: '100%'
      }
    },
    CheckButton: {
      // White-label host: the tenant accent (inert on the platform).
      extends: ['WhitelabelAccent', 'CheckButton'],
      text: (el, s) =>
        el.call('polyglot', s.loading ? 'auth.resetEmail.sending' : 'auth.resetEmail.submit'),
      disabled: (el, s) => !!s.loading,
      opacity: (el, s) => (s.loading ? '.7' : '1'),
      cursor: (el, s) => (s.loading ? 'wait' : 'pointer'),
      pointerEvents: (el, s) => (s.loading ? 'none' : 'auto'),
      type: 'submit',
      Icon: null,
      width: '100%',
      minHeight: 'controlH',
      padding: '0 A',
      fontSize: 'Z2',
      fontWeight: '700',
      '@mobileL': {
        width: '100%',
        maxWidth: '100%'
      }
    }
  }
}
